import { render, staticRenderFns } from "./bottom-toolbar.vue?vue&type=template&id=a22a362a"
import script from "./bottom-toolbar.vue?vue&type=script&lang=js"
export * from "./bottom-toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports